const forwardTouchStartEventToInput = (
  originalEvent: React.TouchEvent,
  inputEl: HTMLElement | undefined | null
): void => {
  forwardTouchEventToInput('touchstart', originalEvent, inputEl);
};

const forwardTouchEndEventToInput = (
  originalEvent: React.TouchEvent,
  inputEl: HTMLElement | undefined | null
): void => {
  forwardTouchEventToInput('touchend', originalEvent, inputEl);
};

const forwardTouchEventToInput = (
  eventName: string,
  originalEvent: React.TouchEvent,
  inputEl: HTMLElement | undefined | null
): void => {
  const changedTouches: Touch[] = [];

  for (let i = 0; i < originalEvent.changedTouches?.length; i++) {
    changedTouches.push(originalEvent.changedTouches?.item(i) as Touch);
  }

  const event = new TouchEvent(eventName, {
    changedTouches,
  });

  inputEl?.dispatchEvent(event);
};

export { forwardTouchStartEventToInput, forwardTouchEndEventToInput };
